import List from 'Components/List';
import { Dispatch, SetStateAction, useState } from 'react';

import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';

import ListItem from '../../Components/ListItem';
import ListItemAction from '../../Components/ListItemAction';
import ListItemActions from '../../Components/ListItemActions';
import ListItemContent from '../../Components/ListItemContent';
import Tile from '../../Components/Tiles/Tile';
import { SaleDealerInformationItem, Vehicle } from '../../system/Domain';
import SaleDealerInformationListItem from './SaleDealerInformationListItem';

interface Props {
	vehicle: Vehicle;
	setVehicle: Dispatch<SetStateAction<Vehicle | undefined>>;
	disabled?: boolean;
}

const SaleDealerInformationTile = ({ vehicle, setVehicle, disabled }: Props) => {
	const [newItem, setNewItem] = useState<Partial<SaleDealerInformationItem>>();

	const items = vehicle.remarketing.dealerInformation ?? [];

	const addNew = () => setNewItem({});
	const cancel = () => setNewItem(undefined);
	const saveNew = (updatedVehicle: Vehicle) => {
		setNewItem(undefined);
		setVehicle(updatedVehicle);
	};
	const saveEdit = (updatedVehicle: Vehicle) => setVehicle(updatedVehicle);

	return (
		<Tile title="Händlerinformationen">
			<List>
				{disabled && items.length === 0 && (
					<ListItem transparent>
						<ListItemContent>Keine Händlerinformationen vorhanden</ListItemContent>
					</ListItem>
				)}
				{!disabled && !newItem && (
					<ListItem transparent>
						<ListItemActions>
							<ListItemAction icon={<Add />} onClick={addNew} />
						</ListItemActions>
						<ListItemContent onClick={addNew}>
							<Typography variant="subtitle2">Händlerinformation hinzufügen</Typography>
						</ListItemContent>
					</ListItem>
				)}
				{!disabled && newItem && (
					<SaleDealerInformationListItem
						item={newItem}
						new
						cancel={cancel}
						vehicle={vehicle}
						save={saveNew}
					/>
				)}
				{items.map(item => (
					<SaleDealerInformationListItem
						key={item.id}
						item={item}
						vehicle={vehicle}
						save={saveEdit}
						disabled={disabled}
					/>
				))}
			</List>
		</Tile>
	);
};

export default SaleDealerInformationTile;
